module.exports = __webpack_public_path__ + "media/images/svg-icon-d6cfe4405646936089e410f0438076a5.svg";